export const userKeys = {
  all: ['users'],
  list: (params: any) => ['users', 'list', params],
  detail: (id: any) => ['users', 'detail', id],
};
